import { ReactComponent as Grid } from 'assets/icons/icon-grid.svg';

export default Grid;
